
export default {
  sceneArrow: null, // require(`@/assets/icons/scene_arrow.png`),
  carouselArrow: null, // require(`@/assets/icons/carousel_arrow.png`),
  carouselArrowHover: null, // require(`@/assets/icons/carousel_arrow_hover.png`),
  video: require(`@/assets/icons/icon_video.svg`),
  download: require(`@/assets/icons/icon_download.svg`),
};
